// extracted by mini-css-extract-plugin
export var shell = "Shell-module--shell--1G8Kv";
export var show = "Shell-module--show--bexrV";
export var showFadeInDown = "Shell-module--show-fade-in-down--VYyI1";
export var showFadeInUp = "Shell-module--show-fade-in-up--2MUfu";
export var hideFadeOut = "Shell-module--hide-fade-out--B-ugV";